export default __webpack_public_path__ + "static/michigan-7-2b4c50db235fbb138422657693881995.jpg";